module.exports = __webpack_public_path__ + "img/pa.9f061c6f.svg";